<template>
  <div class="content">

    <div :class="{'not-allowed': !$root.checkFeature('auto_messages')}"
         class="d-block-create-msg">
      <div class="container-fluid" :class="{'is-template': isTemplate}">
        <div class="row">
          <div class="col-md-6 col-sm-12 left-column">
            <h1 class="page-title">
              <span>Auto Messages</span>
              <span class="del-text">Customize your automatic text messages</span>
            </h1>
            <router-link v-for="(message, index) in messages"
                         :key="index"
                         :to="{name: 'AutoMessagesEdit', params: {msgId: message.id}}"
                         class="auto-msg-bl auto-msg-bl-hover text-center">
              <img :src="message.icon" width="60px" height="60px" :alt="message.title">

              <span v-if="parseInt(message.enabled)" class="toggle-wrap">
                <font-awesome-icon :icon="['fas', 'toggle-on']"/>
              </span>

              <span v-else class="toggle-wrap">
                <font-awesome-icon class="fa-flip-horizontal" :icon="['fas', 'toggle-on']"/>
              </span>
              <b>{{message.title}}</b>
              <p>{{message.desc}}</p>
            </router-link>
            <div class="clearfix"></div>

          </div>
          <div class="col-md-6 col-sm-12 right-column">
            <div class="preview-msg clearfix">
              <div class="inner">
                <div class="wrap" v-if="activeCharityInfo">
                  <div class="ch-logo">
                    <img v-if="activeCharityInfo.logo_transparent"
                         :src="activeCharityInfo.logo_transparent"
                         :alt="activeCharityInfo.charity_name">
                  </div>
                  <div class="ch-name">{{activeCharityInfo.charity_name}}</div>
                </div>
                <div class="text-center secondary-bar">
                  <strong>Select an Auto Message</strong>
                  <p>Then create or edit the message that you send</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MsgMenu from './menu.vue';
  import Switches from 'vue-switches';
  import {getAllAutoMessages} from '@/utils/api';
  import {defParams} from '@/utils/messages';
  import merge from 'deepmerge';
  import {mapState} from "vuex";

  export default {
    name: 'AutoMessages',
    props: [
      'isTemplate',
      'isNew',
    ],
    components: {
      MsgMenu,
      Switches,
    },
    metaInfo: {
      title: 'Auto Messages',
    },
    mounted() {
      getAllAutoMessages().then(res => this.allMessages = res);
    },
    computed: {
      ...mapState({
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      messages() {
        if (!this.allMessages) {
          return [];
        }
        return this.allMessages.map(msg => merge(defParams[msg.id], msg));
      },
      filteredMessages() {
        return this.messages;
      },
    },
    data() {
      return {
        allMessages: null,
        welcomeMessage: true,
      };
    },
  };
</script>

<style lang="sass">
  .d-block-create-msg
    position: static

    .msg-text
      white-space: pre-wrap

    .auto-msg-bl
      .toggle-wrap
        display: block
        position: absolute
        top: 10px
        right: 10px

      .fa-toggle-on
        color: #0d70e3

      .fa-toggle-on.fa-flip-horizontal
        color: #e0e6ed
</style>
